import {
  useEffect,
  useState
} from "react";

import {
  useNavigate
} from "react-router-dom";

import API from "../../services/api";

function TransferMoney() {

  const navigate =
    useNavigate();

  const [wallets,
    setWallets] =
    useState([]);

  const [form,
    setForm] =
    useState({

      from_wallet: "",

      to_wallet: "",

      amount: "",

      description: ""

    });

  useEffect(() => {

    loadWallets();

  }, []);

  const loadWallets =
    async () => {

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        const res =
          await API.get(
            "/wallets",
            {
              headers: {
                Authorization:
                  `Bearer ${token}`
              }
            }
          );

        setWallets(
          res.data.wallets || []
        );

      } catch (err) {

        console.log(err);

      }

    };

  const submit =
    async (e) => {

      e.preventDefault();

      if (
        form.from_wallet ===
        form.to_wallet
      ) {

        return alert(
          "From & To Wallet cannot be same."
        );

      }

      try {

        const token =
          localStorage.getItem(
            "adminToken"
          );

        await API.post(
          "/wallets/transfer",

          form,

          {
            headers: {
              Authorization:
                `Bearer ${token}`
            }
          }

        );

        navigate(
          "/admin/wallets"
        );

      } catch (err) {

        console.log(err);

        alert(
          err.response?.data?.message ||
          "Transfer Failed"
        );

      }

    };

  return (

    <div>

      <h1
        className="
        text-4xl
        font-bold
        mb-8
        "
      >
        Transfer Money
      </h1>

      <form
        onSubmit={submit}
        className="
        bg-[#111]
        rounded-2xl
        p-8
        max-w-2xl
        "
      >

        {/* From Wallet */}

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            "
          >
            From Wallet
          </label>

          <select
            required
            value={
              form.from_wallet
            }
            onChange={(e)=>
              setForm({
                ...form,
                from_wallet:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          >

            <option value="">
              Select Wallet
            </option>

            {wallets.map(
              wallet => (

                <option
                  key={wallet.id}
                  value={wallet.id}
                >
                  {wallet.wallet_name}
                  {" "}
                  (₹
                  {
                    Number(
                      wallet.balance
                    ).toFixed(2)
                  }
                  )
                </option>

              )
            )}

          </select>

        </div>

        {/* To Wallet */}

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            "
          >
            To Wallet
          </label>

          <select
            required
            value={
              form.to_wallet
            }
            onChange={(e)=>
              setForm({
                ...form,
                to_wallet:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          >

            <option value="">
              Select Wallet
            </option>

            {wallets.map(
              wallet => (

                <option
                  key={wallet.id}
                  value={wallet.id}
                >
                  {wallet.wallet_name}
                  {" "}
                  (₹
                  {
                    Number(
                      wallet.balance
                    ).toFixed(2)
                  }
                  )
                </option>

              )
            )}

          </select>

        </div>

        {/* Amount */}

        <div className="mb-6">

          <label
            className="
            block
            mb-2
            "
          >
            Amount
          </label>

          <input
            type="number"
            min="1"
            required
            value={
              form.amount
            }
            onChange={(e)=>
              setForm({
                ...form,
                amount:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        {/* Description */}

        <div className="mb-8">

          <label
            className="
            block
            mb-2
            "
          >
            Description
          </label>

          <textarea
            rows="4"
            value={
              form.description
            }
            onChange={(e)=>
              setForm({
                ...form,
                description:
                  e.target.value
              })
            }
            className="
            w-full
            p-3
            rounded-xl
            bg-black
            border
            border-yellow-500/20
            "
          />

        </div>

        <div
          className="
          flex
          gap-3
          flex-wrap
          "
        >

          <button
            type="submit"
            className="
            bg-yellow-500
            text-black
            px-6
            py-3
            rounded-xl
            font-semibold
            "
          >
            Transfer
          </button>

          <button
            type="button"
            onClick={() =>
              navigate(
                "/admin/wallets"
              )
            }
            className="
            bg-gray-700
            px-6
            py-3
            rounded-xl
            "
          >
            Cancel
          </button>

        </div>

      </form>

    </div>

  );

}

export default TransferMoney;